export default "__VITE_ASSET__ea951a96__"